module.exports = __webpack_public_path__ + "static/favicon-cc054b9371e9c06623c0353ede165414.png";